import React, {ReactNode} from 'react'
import {Paper, Stack, Typography} from '@mui/material'
import {SxType} from '@baseTypes/sx/sxTypes'

interface IProps {
	title?: ReactNode
	action?: ReactNode
	children: ReactNode
	sx?: SxType
}

const DashboardCard = ({title, action, children, sx}: IProps) => {
	return (
		<Paper
			variant={'outlined'}
			sx={{borderRadius: '12px', padding: '14px 16px', minWidth: 0, ...sx}}
		>
			{(title || action) && <Stack
				direction={'row'}
				alignItems={'center'}
				justifyContent={'space-between'}
				gap={1}
				mb={1.5}
			>
				<Typography variant={'subtitle1'} fontWeight={600}>{title}</Typography>
				{action}
			</Stack>}
			{children}
		</Paper>
	)
}

export default DashboardCard
